/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthorisePaymentRequest,
  AuthorisePaymentResponse,
  CancelPaymentDto,
  ClientPaymentDto,
  ErrorMessage,
  InhousePaymentDto,
  InitiatePaymentRequest,
  InitiatePaymentResponse,
  InitiateRefundRequest,
  InitiateRefundResponse,
  OverridePaymentStateDto,
  PageInhousePaymentDto,
  PaymentEventDto,
  PaymentStatusResponse,
} from '../models/index';
import {
    AuthorisePaymentRequestFromJSON,
    AuthorisePaymentRequestToJSON,
    AuthorisePaymentResponseFromJSON,
    AuthorisePaymentResponseToJSON,
    CancelPaymentDtoFromJSON,
    CancelPaymentDtoToJSON,
    ClientPaymentDtoFromJSON,
    ClientPaymentDtoToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    InhousePaymentDtoFromJSON,
    InhousePaymentDtoToJSON,
    InitiatePaymentRequestFromJSON,
    InitiatePaymentRequestToJSON,
    InitiatePaymentResponseFromJSON,
    InitiatePaymentResponseToJSON,
    InitiateRefundRequestFromJSON,
    InitiateRefundRequestToJSON,
    InitiateRefundResponseFromJSON,
    InitiateRefundResponseToJSON,
    OverridePaymentStateDtoFromJSON,
    OverridePaymentStateDtoToJSON,
    PageInhousePaymentDtoFromJSON,
    PageInhousePaymentDtoToJSON,
    PaymentEventDtoFromJSON,
    PaymentEventDtoToJSON,
    PaymentStatusResponseFromJSON,
    PaymentStatusResponseToJSON,
} from '../models/index';

export interface AuthorisePaymentOperationRequest {
    paymentReference: string;
    authorisePaymentRequest: AuthorisePaymentRequest;
}

export interface CancelPaymentRequest {
    paymentReference: string;
}

export interface GetPaymentRequest {
    paymentReference: string;
}

export interface GetPayment1Request {
    paymentReference: string;
}

export interface GetPaymentEventsRequest {
    paymentReference: string;
}

export interface GetPaymentReferencesRequest {
    includeSucceededOnly?: boolean;
    fromDateTime?: Date;
    toDateTime?: Date;
}

export interface GetPaymentStatusRequest {
    paymentReference: string;
    redirectResult?: string;
}

export interface GetPaymentsRequest {
    updatedBetweenFrom?: Date;
    updatedBetweenTo?: Date;
    pageNo?: number;
    pageSize?: number;
    sortBy?: string;
    direction?: GetPaymentsDirectionEnum;
}

export interface GetPayments1Request {
    pageNo?: number;
    pageSize?: number;
    sortBy?: string;
    direction?: GetPayments1DirectionEnum;
    total?: boolean;
}

export interface InitiateCancelRequest {
    cancelPaymentDto: CancelPaymentDto;
}

export interface InitiateCaptureRequest {
    paymentReference: string;
}

export interface InitiatePaymentOperationRequest {
    initiatePaymentRequest: InitiatePaymentRequest;
}

export interface InitiateRefundOperationRequest {
    paymentReference: string;
    initiateRefundRequest: InitiateRefundRequest;
}

export interface OverridePaymentStateRequest {
    paymentReference: string;
    overridePaymentStateDto: OverridePaymentStateDto;
}

export interface RetryCaptureRequest {
    paymentReference: string;
}

export interface SearchInPaymentsRequest {
    query: string;
    pageNo?: number;
    pageSize?: number;
    sortBy?: string;
    direction?: SearchInPaymentsDirectionEnum;
    total?: boolean;
}

export interface WashPaymentRequest {
    paymentReference: string;
}

/**
 * 
 */
export class PaymentControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for authorisePayment without sending the request
     */
    async authorisePaymentRequestOpts(requestParameters: AuthorisePaymentOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling authorisePayment().'
            );
        }

        if (requestParameters['authorisePaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'authorisePaymentRequest',
                'Required parameter "authorisePaymentRequest" was null or undefined when calling authorisePayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/public-open/payments/{paymentReference}/authorise`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthorisePaymentRequestToJSON(requestParameters['authorisePaymentRequest']),
        };
    }

    /**
     */
    async authorisePaymentRaw(requestParameters: AuthorisePaymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthorisePaymentResponse>> {
        const requestOptions = await this.authorisePaymentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthorisePaymentResponseFromJSON(jsonValue));
    }

    /**
     */
    async authorisePayment(requestParameters: AuthorisePaymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthorisePaymentResponse> {
        const response = await this.authorisePaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for cancelPayment without sending the request
     */
    async cancelPaymentRequestOpts(requestParameters: CancelPaymentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling cancelPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/public-open/payments/{paymentReference}/cancel`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async cancelPaymentRaw(requestParameters: CancelPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.cancelPaymentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelPayment(requestParameters: CancelPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelPaymentRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getPayment without sending the request
     */
    async getPaymentRequestOpts(requestParameters: GetPaymentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling getPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payments/{paymentReference}`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentRaw(requestParameters: GetPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InhousePaymentDto>> {
        const requestOptions = await this.getPaymentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InhousePaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async getPayment(requestParameters: GetPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InhousePaymentDto> {
        const response = await this.getPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPayment1 without sending the request
     */
    async getPayment1RequestOpts(requestParameters: GetPayment1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling getPayment1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payments/{paymentReference}`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPayment1Raw(requestParameters: GetPayment1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientPaymentDto>> {
        const requestOptions = await this.getPayment1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientPaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async getPayment1(requestParameters: GetPayment1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientPaymentDto> {
        const response = await this.getPayment1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentEvents without sending the request
     */
    async getPaymentEventsRequestOpts(requestParameters: GetPaymentEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling getPaymentEvents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payments/{paymentReference}/events`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentEventsRaw(requestParameters: GetPaymentEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaymentEventDto>>> {
        const requestOptions = await this.getPaymentEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentEventDtoFromJSON));
    }

    /**
     */
    async getPaymentEvents(requestParameters: GetPaymentEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaymentEventDto>> {
        const response = await this.getPaymentEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentReferences without sending the request
     */
    async getPaymentReferencesRequestOpts(requestParameters: GetPaymentReferencesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['includeSucceededOnly'] != null) {
            queryParameters['includeSucceededOnly'] = requestParameters['includeSucceededOnly'];
        }

        if (requestParameters['fromDateTime'] != null) {
            queryParameters['fromDateTime'] = (requestParameters['fromDateTime'] as any).toISOString();
        }

        if (requestParameters['toDateTime'] != null) {
            queryParameters['toDateTime'] = (requestParameters['toDateTime'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payments/references`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentReferencesRaw(requestParameters: GetPaymentReferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.getPaymentReferencesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getPaymentReferences(requestParameters: GetPaymentReferencesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getPaymentReferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentStatus without sending the request
     */
    async getPaymentStatusRequestOpts(requestParameters: GetPaymentStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling getPaymentStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['redirectResult'] != null) {
            queryParameters['redirectResult'] = requestParameters['redirectResult'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/public-open/payments/{paymentReference}/status`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentStatusRaw(requestParameters: GetPaymentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentStatusResponse>> {
        const requestOptions = await this.getPaymentStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPaymentStatus(requestParameters: GetPaymentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentStatusResponse> {
        const response = await this.getPaymentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPayments without sending the request
     */
    async getPaymentsRequestOpts(requestParameters: GetPaymentsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['updatedBetweenFrom'] != null) {
            queryParameters['updatedBetweenFrom'] = (requestParameters['updatedBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['updatedBetweenTo'] != null) {
            queryParameters['updatedBetweenTo'] = (requestParameters['updatedBetweenTo'] as any).toISOString();
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payments`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentsRaw(requestParameters: GetPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInhousePaymentDto>> {
        const requestOptions = await this.getPaymentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInhousePaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async getPayments(requestParameters: GetPaymentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInhousePaymentDto> {
        const response = await this.getPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPayments1 without sending the request
     */
    async getPayments1RequestOpts(requestParameters: GetPayments1Request): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['total'] != null) {
            queryParameters['total'] = requestParameters['total'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payments`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPayments1Raw(requestParameters: GetPayments1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientPaymentDto>>> {
        const requestOptions = await this.getPayments1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClientPaymentDtoFromJSON));
    }

    /**
     */
    async getPayments1(requestParameters: GetPayments1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientPaymentDto>> {
        const response = await this.getPayments1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for initiateCancel without sending the request
     */
    async initiateCancelRequestOpts(requestParameters: InitiateCancelRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cancelPaymentDto'] == null) {
            throw new runtime.RequiredError(
                'cancelPaymentDto',
                'Required parameter "cancelPaymentDto" was null or undefined when calling initiateCancel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payments/cancel`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelPaymentDtoToJSON(requestParameters['cancelPaymentDto']),
        };
    }

    /**
     */
    async initiateCancelRaw(requestParameters: InitiateCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.initiateCancelRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async initiateCancel(requestParameters: InitiateCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.initiateCancelRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for initiateCapture without sending the request
     */
    async initiateCaptureRequestOpts(requestParameters: InitiateCaptureRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling initiateCapture().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payments/{paymentReference}/capture`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async initiateCaptureRaw(requestParameters: InitiateCaptureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.initiateCaptureRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async initiateCapture(requestParameters: InitiateCaptureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.initiateCaptureRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for initiatePayment without sending the request
     */
    async initiatePaymentRequestOpts(requestParameters: InitiatePaymentOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['initiatePaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'initiatePaymentRequest',
                'Required parameter "initiatePaymentRequest" was null or undefined when calling initiatePayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payments`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitiatePaymentRequestToJSON(requestParameters['initiatePaymentRequest']),
        };
    }

    /**
     */
    async initiatePaymentRaw(requestParameters: InitiatePaymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiatePaymentResponse>> {
        const requestOptions = await this.initiatePaymentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiatePaymentResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiatePayment(requestParameters: InitiatePaymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiatePaymentResponse> {
        const response = await this.initiatePaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for initiateRefund without sending the request
     */
    async initiateRefundRequestOpts(requestParameters: InitiateRefundOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling initiateRefund().'
            );
        }

        if (requestParameters['initiateRefundRequest'] == null) {
            throw new runtime.RequiredError(
                'initiateRefundRequest',
                'Required parameter "initiateRefundRequest" was null or undefined when calling initiateRefund().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payments/{paymentReference}/refund`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitiateRefundRequestToJSON(requestParameters['initiateRefundRequest']),
        };
    }

    /**
     */
    async initiateRefundRaw(requestParameters: InitiateRefundOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiateRefundResponse>> {
        const requestOptions = await this.initiateRefundRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiateRefundResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiateRefund(requestParameters: InitiateRefundOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiateRefundResponse> {
        const response = await this.initiateRefundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for overridePaymentState without sending the request
     */
    async overridePaymentStateRequestOpts(requestParameters: OverridePaymentStateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling overridePaymentState().'
            );
        }

        if (requestParameters['overridePaymentStateDto'] == null) {
            throw new runtime.RequiredError(
                'overridePaymentStateDto',
                'Required parameter "overridePaymentStateDto" was null or undefined when calling overridePaymentState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payments/{paymentReference}/override-payment-state`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OverridePaymentStateDtoToJSON(requestParameters['overridePaymentStateDto']),
        };
    }

    /**
     */
    async overridePaymentStateRaw(requestParameters: OverridePaymentStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.overridePaymentStateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async overridePaymentState(requestParameters: OverridePaymentStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.overridePaymentStateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for retryCapture without sending the request
     */
    async retryCaptureRequestOpts(requestParameters: RetryCaptureRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling retryCapture().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payments/{paymentReference}/retry-capture`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async retryCaptureRaw(requestParameters: RetryCaptureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.retryCaptureRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async retryCapture(requestParameters: RetryCaptureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.retryCaptureRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for searchInPayments without sending the request
     */
    async searchInPaymentsRequestOpts(requestParameters: SearchInPaymentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling searchInPayments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['total'] != null) {
            queryParameters['total'] = requestParameters['total'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payments/search`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async searchInPaymentsRaw(requestParameters: SearchInPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientPaymentDto>>> {
        const requestOptions = await this.searchInPaymentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClientPaymentDtoFromJSON));
    }

    /**
     */
    async searchInPayments(requestParameters: SearchInPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientPaymentDto>> {
        const response = await this.searchInPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for washPayment without sending the request
     */
    async washPaymentRequestOpts(requestParameters: WashPaymentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling washPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payments/{paymentReference}/wash`;
        urlPath = urlPath.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async washPaymentRaw(requestParameters: WashPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.washPaymentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async washPayment(requestParameters: WashPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.washPaymentRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetPaymentsDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type GetPaymentsDirectionEnum = typeof GetPaymentsDirectionEnum[keyof typeof GetPaymentsDirectionEnum];
/**
 * @export
 */
export const GetPayments1DirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type GetPayments1DirectionEnum = typeof GetPayments1DirectionEnum[keyof typeof GetPayments1DirectionEnum];
/**
 * @export
 */
export const SearchInPaymentsDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type SearchInPaymentsDirectionEnum = typeof SearchInPaymentsDirectionEnum[keyof typeof SearchInPaymentsDirectionEnum];
